<template>
  <div class="d-flex flex-column">
    <div class="subcategory d-flex flex-column justify-space-around align-center py-5">
      <SubcategoryButton
        icon="mdi-water-off-outline"
        text="Unit Is Not Irrigating"
      />
      <SubcategoryButton
        icon="alarm_off"
        text="Irrigation Is Not Following Schedule"
      />
      <SubcategoryButton
        icon="more_horiz"
        text="Other"
      />
    </div>
  </div>
</template>

<script>
import SubcategoryButton from '@/components/repairTickets/SubcategorySelection/SubcategoryButton.vue';

export default {
  name: 'IrrigationSubcategorySelection',
  components: {
    SubcategoryButton,
  },
  methods: {},
};
</script>

<style lang="scss"></style>
